import { render, staticRenderFns } from "./crudSettings.vue?vue&type=template&id=dca2dd4a"
import script from "./crudSettings.vue?vue&type=script&lang=js"
export * from "./crudSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports